import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

export const fetchSpaces = async () => {
  const response = await axios.get(`${API_URL}/spaces`, { headers: authHeaders() });
  return Array.isArray(response.data) ? response.data : [];
};

export const fetchSpaceAnalytics = async (targetUserId) => {
  const params = targetUserId ? { targetUserId } : {};
  const response = await axios.get(`${API_URL}/spaces/analytics`, {
    headers: authHeaders(),
    params,
  });
  return Array.isArray(response.data) ? response.data : [];
};

export const createSpace = async (name, icon) => {
  const response = await axios.post(
    `${API_URL}/spaces`,
    { name, icon },
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSpace = async (id, { name, icon } = {}) => {
  const body = {};
  if (name !== undefined) body.name = name;
  if (icon !== undefined) body.icon = icon;
  const response = await axios.patch(
    `${API_URL}/spaces/${id}`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSpaceIcon = async (id, icon) => updateSpace(id, { icon: icon || '' });
